import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Notification from './common/Notification';
import SideBar from '../collums-components/components/common/Sidebar';
import BuildStamp from '../collums-components/components/common/BuildStamp';
import ShowPINModal from '../collums-components/components/common/PINModal/index';
import LogoutModal from '../collums-components/components/common/LogoutModal';
import EnvironmentDisabled from './../collums-components/components/common/EnvironmentDisabled';

import { useCookies } from 'react-cookie';
import { isAvailableByPlan } from '../collums-constants/utils';
import { COLLUMS_APPS_ACCESS_TIER } from '../collums-constants';

import BootstrapAuth from './BootstrapAuth';

import '../styles/App.css';

const App = ({ children }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [cookies] = useCookies();

    if (!isInitialized) {
        return <BootstrapAuth onReady={() => setIsInitialized(true)} />;
    }

    if (!isAvailableByPlan(COLLUMS_APPS_ACCESS_TIER.ADMIN)) {
        return <EnvironmentDisabled />;
    }

    return (
        <div className="container-fluid">
            <div className="App">
                <ShowPINModal />
                {cookies.logoutActive === 'true' && <LogoutModal />}
                <>
                    <div className="Page-view">
                        <div>{children}</div>
                        <Notification />
                    </div>
                    <BuildStamp />
                    <SideBar appName="admin" />
                </>
            </div>
        </div>
    );
};

App.propTypes = {
    children: PropTypes.any.isRequired
};

export default App;
